<template>
	<div class="">
		<h3 class="dashboard-list-title">
			{{ title}}
		    <div class="job-request-list-filter">
		        <div v-bind:class="{ 'selected': appliedFilter == 'all' }" v-on:click="applyFilter">all</div>
		        <div v-bind:class="{ 'selected': appliedFilter == '24h' }" v-on:click="applyFilter">24h</div>
		        <div v-bind:class="{ 'selected': appliedFilter == '1w' }" v-on:click="applyFilter">1w</div>
		    </div>
		 </h3>
		<div class="table__container--parent">
		    <div class="table__container--outer">
		        <div class="table__container--block">

		            <div class="table__container--wrapper">
		                <div class="table__container--labels">
		                    <div></div>
		                    <div class="table__container--label">No</div>
		                    <div class="table__container--label">Date</div>
		                    <div class="table__container--label">Candidate</div>
		                    <div class="table__container--label">B&nbsp;CV</div>
		                    <div class="table__container--label">Position</div>
		                    <div
                                v-if="showRecruiterColumn" 
                                class="table__container--label">
                                Recruiter
                            </div>
		                </div>
		            </div>  
		        </div>
		    </div>
		</div>
	</div>
</template>

<script>
import Ajax from '../form-field/sub-components/js/ajax.js'

export default {
    props: [
        'url',
        'titleData',
        'showRecruiterColumn'
    ],
    data: function(){
        return {
            appliedFilter: 'all',
            title: this.titleData
        }
    },
    mounted: function(){
        this.applyFilter({
            target: this.$el.querySelectorAll('.job-request-list-filter > div')[0]
        });
    },
    methods: {
        applyFilter: function(event){
    
            const listParent = $(this.$el).find(`.table__container--outer`)[0];

            this.appliedFilter = event.target.innerText;
            console.log(event.target.innerText)

            console.log(`${this.url}${this.appliedFilter}`)

            Ajax.sendRequest('GET',{},`${this.url}${this.appliedFilter}`,(response) => {
               // console.log(response);
                // const listParent = event.target.parentElement.parentElement.parentElement;
                listParent.querySelectorAll('.table__container--single').forEach((row) => { row.remove() });
                
                const html = response.results.map((Result) => {
                    return/*html*/`
                        <div class="table__container--single">
                            <a href="#" class="flaticon2-arrow table-dropdown"></a>
                            <div class="table__container--content table__cell--8">${Result.job_request.request_nr}</div>
                            <div class="table__container--content table__cell--10">${Result.date}</div>
                            <div class="table__container--content" title="${Result.candidate.registered_on}">
                                ${Result.candidate.flag ? /*html*/`
                                    <div title="${Result.candidate.flag.name}" style="background-color: ${Result.candidate.flag.color};" class="candidate-flag"></div>
                                ` : ``}
                                <a href="${Result.candidate.edit_link}">${Result.candidate.name}</a>
                            </div>

                            <div class="table__container--content table-mid table__cell--8" data-label='B CV'> 
                                ${Result.candidate.latest_bcv_url ?  
                                    `<a href="${ Result.candidate.latest_bcv_url }" target="_blank" title="View latest B CV">
                                        <i class="flaticon2-file-1"></i>
                                        <div>${ Result.candidate.latest_bcv_uploaded }</div>
                                    </a>` 
                                    : `` }
                            </div>

                            <div class="table__container--content">
                                ${Result.job_request.highlighted ? /*html*/`
                                    <div class="job-request-highlighted" title="Highlighted"></div>
                                ` : /*html*/``}
                                <a href="${Result.job_request.edit_link}">${Result.job_request.job_title}</a>
                            </div>
                            <div style="display: ${this.showRecruiterColumn ? 'block' : 'none'}" class="table__container--content">${Result.staff}<br>${Result.shared_with_staff || ''}</div>
                        </div>
                    `;
                }).join(``);

                listParent.querySelectorAll('.table__container--wrapper')[0].innerHTML += html;
            });
        }
    }
}
</script>